import { FC, ReactNode } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export interface HomeBanner {
  type: 'single-1' | 'single-2';
  src?: string;
  description: string;
  buttonTitle?: string;
}
export interface HomeBannerGridProps {
  highLightOffers: HomeBanner[];
}

export const HightlightBannerLayout: FC<{
  banner: ReactNode;
  footer: ReactNode;
  type: 'single-1' | 'single-2';
  highlight?: boolean;
  pip?: ReactNode;
}> = ({ banner, footer, type, highlight, pip }) => {
  return (
    <div
      className={cn('relative h-[168px] w-full', {
        'col-span-2': type === 'single-1',
        'col-span-1': type === 'single-2',
      })}
    >
      <div
        className={cn('overflow-hidden', {
          'rainbow animate-rotate-360 rounded-none': highlight,
        })}
      >
        <div className="bg-text600 absolute inset-0" />
        <div
          className={cn('relative h-[126px] w-full', {
            'h-[120px]': highlight,
          })}
        >
          {banner}
        </div>
        <div className="relative h-[42px] w-full bg-[url('assets/images/home/rectangle.webp')] bg-cover bg-left">
          {footer}
        </div>
      </div>
      {pip}
    </div>
  );
};

export const HighlightBannerPip = () => {
  return (
    <div className="absolute right-0 top-0 z-10 h-5 w-5 -translate-y-1/2 translate-x-1/2">
      <div className="absolute inset-0 animate-ping rounded-full border border-[#E287B3] bg-[#EE2970]" />
      <div className="absolute inset-0 rounded-full border border-[#E287B3] bg-[#EE2970]" />
    </div>
  );
};

export const HighlightBanner1Button = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <button className="flex h-full min-w-[120px] items-center justify-center rounded-lg bg-[url('assets/images/home/highlight-button.webp')] bg-cover px-4 text-xs font-semibold uppercase">
      <span
        className="drop-shadow-text block w-[92px] truncate text-white"
        style={{
          textShadow:
            '2px 2px 4px rgba(0, 0, 0, 0.6), 1px 1px 2px rgba(0, 0, 0, 0.7)',
        }}
      >
        {children}
      </span>
    </button>
  );
};

export const HomeBannerFooter: FC<{
  type: 'single-1' | 'single-2';
  description: ReactNode;
  button: ReactNode;
}> = ({ type, description, button }) => {
  switch (type) {
    case 'single-1':
      return (
        <div className="flex h-full w-full items-center justify-between bg-cover bg-center px-5 py-2 text-[14px] font-bold">
          <div className="drop-shadow-text truncate pr-[2px] pt-[2px] text-[17px] uppercase italic text-white">
            {description}
          </div>
          <div className="h-[26px] items-center justify-center">{button}</div>
        </div>
      );
    case 'single-2':
      return (
        <div className="flex h-full w-full items-center justify-between bg-[url('assets/images/home/rectangle.webp')] bg-cover bg-left px-5 py-2 text-[14px] font-bold">
          <div className="drop-shadow-text truncate pr-[2px] pt-[2px] text-[17px] uppercase italic text-white">
            {description}
          </div>
          <div className="h-4">{'>>'}</div>
        </div>
      );
  }
};

export const HighlightSection = ({ children }: { children: ReactNode }) => {
  return (
    <div className="3xl:grid-cols-6 grid grid-cols-2 flex-wrap justify-between gap-3 md:grid-cols-4">
      {children}
    </div>
  );
};
